module.exports = __webpack_public_path__ + "assets/img/f8c503fb01cd4c6fc8085af2f4245864.webp";